import { Component, input } from '@angular/core';

import { CustomPageComponentsMap } from '../models';

/**
 * Base class for all custom page block components.
 * Used to enforce the data property to be present and type safe.
 */
@Component({ template: '' })
export abstract class CustomPageBlockComponent<T extends keyof CustomPageComponentsMap> {
  data = input.required<CustomPageComponentsMap[T]>();
}
